// extracted by mini-css-extract-plugin
export default {"paragraph":"Paragraph_paragraph__9998Q","small-paragraph":"Paragraph_small-paragraph__QT263","paragraph-blue":"Paragraph_paragraph-blue__t+ZIr"};